var notifies = {
    methods: {
        notify: function (message, status, timeout, position) {
            // eslint-disable-next-line
            UIkit.notify({
                message: message,
                status: status || "info",
                timeout: (timeout === 0) ? timeout : (timeout || 7000),
                pos: position || "top-center"
            })
        }
    }
}

export default notifies
